import { dollars } from './buildings';
import { NetworkKind } from './ground';

export const STARTING_MONEY = dollars(250_000);

export interface NetworkDef {
  /** Width of the painted band, in tiles. */
  readonly width: number;
  /** Cents per tile. */
  readonly cost: number;
}

export const NETWORKS: Readonly<Record<number, NetworkDef>> = {
  // Two lanes each way.
  [NetworkKind.Road]: { width: 4, cost: dollars(12) },
  // One lane each way, for the airport's own vehicles.
  [NetworkKind.Service]: { width: 2, cost: dollars(8) },
  // Laid in 3×3 blocks; the yellow centre line aircraft follow is painted separately.
  [NetworkKind.Taxiway]: { width: 4, cost: dollars(40) },
};

/** Painting one tile of taxiway centre line. */
export const TAXI_LINE_COST = dollars(5);
/** Largest taxiway area (tiles per side) one paving command may cover. */
export const MAX_PAVE_SPAN = 48;
/** Longest airport name, in characters. */
export const MAX_AIRPORT_NAME = 32;

/** Price of the first parcel bought beyond the starting land. */
export const PARCEL_BASE_PRICE = dollars(30_000);
/**
 * Each further parcel costs this percentage of the previous one (135 % made the fifth cost four
 * times the first and stopped growth; the 0.53 playtest).
 */
export const PARCEL_PRICE_GROWTH_PERCENT = 117;

/** Price of the next parcel after `bought` purchases. Integer-only so it stays deterministic. */
export function parcelPrice(bought: number): number {
  let price = PARCEL_BASE_PRICE;
  for (let i = 0; i < bought; i++) price = Math.floor((price * PARCEL_PRICE_GROWTH_PERCENT) / 100);
  return price;
}

/** Share of the build cost returned on demolition, as a percentage. */
export const REFUND_PERCENT = 50;

export function refundOf(cost: number): number {
  return Math.floor((cost * REFUND_PERCENT) / 100);
}
